import { createSelector } from 'reselect';
import { selectHomeTabPreference } from '../../selectors/user';

export default createSelector([selectHomeTabPreference], (homeTab) => ({
  homeTab,
}));
